"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationCamera',
  data: function data() {
    return {
      loading: false,
      drawerVisible: false,
      detail: null,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        projectId: '',
        status: '',
        onlineStatus: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      statusTag: {
        pending: 'warning',
        in_use: 'success',
        disabled: 'info',
        removed: 'danger'
      },
      onlineTag: {
        online: 'success',
        offline: 'info',
        fault: 'danger'
      }
    };
  },
  computed: {
    inUseCount: function inUseCount() {
      return this.tableData.data.filter(function (item) {
        return item.camera.status === 'in_use';
      }).length;
    },
    pendingCount: function pendingCount() {
      return this.tableData.data.filter(function (item) {
        return item.camera.status === 'pending';
      }).length;
    },
    onlineCount: function onlineCount() {
      return this.tableData.data.filter(function (item) {
        return item.camera.onlineStatus === 'online';
      }).length;
    },
    expiredCount: function expiredCount() {
      return this.tableData.data.filter(function (item) {
        return item.serviceExpired;
      }).length;
    },
    projectOptions: function projectOptions() {
      var values = {};
      this.tableData.data.forEach(function (item) {
        if (item.project) values[item.project.id] = item.project.projectName;
      });
      return Object.keys(values).map(function (id) {
        return {
          id: Number(id),
          name: values[id]
        };
      });
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    statusText: function statusText(value) {
      return {
        pending: '待安装',
        in_use: '使用中',
        disabled: '已停用',
        removed: '已拆除'
      }[value] || value;
    },
    onlineText: function onlineText(value) {
      return {
        online: '在线',
        offline: '离线',
        fault: '故障'
      }[value] || value;
    },
    rolePolicy: function rolePolicy(policy) {
      var roles = policy && policy.roles || [];
      return roles.length ? roles.join(' / ') : '项目成员均可看';
    },
    hourPolicy: function hourPolicy(policy) {
      var hours = policy && policy.hours || [0, 24];
      return "".concat(hours[0], ":00-").concat(hours[1], ":00");
    },
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationCameraListApi)(this.searchForm).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        page: 1,
        limit: this.searchForm.limit,
        keywords: '',
        projectId: '',
        status: '',
        onlineStatus: ''
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.searchForm.limit = value;
      this.searchForm.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.getList();
    },
    openDetail: function () {
      var _openDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _decoration.decorationCameraDetailApi)(row.camera.id);
            case 1:
              this.detail = _context.v;
              this.drawerVisible = true;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error(_t.message || '详情加载失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function openDetail(_x) {
        return _openDetail.apply(this, arguments);
      }
      return openDetail;
    }(),
    confirmAction: function confirmAction(row, action) {
      var _this2 = this;
      var labels = {
        install: '确认安装',
        online: '标记在线',
        offline: '标记离线',
        fault: '标记故障',
        disable: '停用',
        enable: '恢复使用',
        remove: '拆除',
        delete: '删除'
      };
      this.$confirm("".concat(labels[action], "\u201C").concat(row.camera.deviceName, "\u201D\uFF1F"), '摄像头管理', {
        type: ['remove', 'delete'].includes(action) ? 'warning' : 'info'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var result, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _decoration.decorationCameraActionApi)(row.camera.id, {
                action: action
              });
            case 1:
              result = _context2.v;
              if (action === 'delete') {
                _this2.drawerVisible = false;
                _this2.detail = null;
              } else if (_this2.detail && _this2.detail.camera.id === row.camera.id) _this2.detail = result;
              _context2.n = 2;
              return _this2.getList();
            case 2:
              _this2.$message.success("".concat(labels[action], "\u6210\u529F"));
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              _this2.$message.error(_t2.message || '操作失败');
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 3]]);
      }))).catch(function () {});
    }
  }
};